/** Default when image load fails; matches “large” carousel cards on the home page. */
export const HOTEL_SECTION_PLACEHOLDER_LARGE =
  'https://images.unsplash.com/photo-1566073771259-6a8506099945?w=800&h=600&fit=crop';

/** Smaller tiles (e.g. Browse by property type). */
export const HOTEL_SECTION_PLACEHOLDER_SMALL =
  'https://images.unsplash.com/photo-1566073771259-6a8506099945?w=400&h=300&fit=crop';

const FALLBACK_LARGE = [
  'https://images.unsplash.com/photo-1566073771259-6a8506099945?w=800&h=600&fit=crop',
  'https://images.unsplash.com/photo-1571896349842-33c89424de2d?w=800&h=600&fit=crop',
  'https://images.unsplash.com/photo-1551882547-ff40c63fe5fa?w=800&h=600&fit=crop',
  'https://images.unsplash.com/photo-1596436889106-be35e843f974?w=800&h=600&fit=crop',
  'https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?w=800&h=600&fit=crop',
  'https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?w=800&h=600&fit=crop',
  'https://images.unsplash.com/photo-1582719508461-905c673771fd?w=800&h=600&fit=crop',
  'https://images.unsplash.com/photo-1542314831-068cd1dbfeeb?w=800&h=600&fit=crop',
  'https://images.unsplash.com/photo-1501117716987-c8e1ecb21080?w=800&h=600&fit=crop',
  'https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=800&h=600&fit=crop',
  'https://images.unsplash.com/photo-1618773928121-c32242e63f39?w=800&h=600&fit=crop',
  'https://images.unsplash.com/photo-1564501049412-61c2a3083791?w=800&h=600&fit=crop',
];

const FALLBACK_SMALL = [
  'https://images.unsplash.com/photo-1566073771259-6a8506099945?w=400&h=300&fit=crop',
  'https://images.unsplash.com/photo-1571896349842-33c89424de2d?w=400&h=300&fit=crop',
  'https://images.unsplash.com/photo-1551882547-ff40c63fe5fa?w=400&h=300&fit=crop',
  'https://images.unsplash.com/photo-1596436889106-be35e843f974?w=400&h=300&fit=crop',
  'https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?w=400&h=300&fit=crop',
  'https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?w=400&h=300&fit=crop',
  'https://images.unsplash.com/photo-1582719508461-905c673771fd?w=400&h=300&fit=crop',
  'https://images.unsplash.com/photo-1542314831-068cd1dbfeeb?w=400&h=300&fit=crop',
  'https://images.unsplash.com/photo-1501117716987-c8e1ecb21080?w=400&h=300&fit=crop',
  'https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=400&h=300&fit=crop',
  'https://images.unsplash.com/photo-1618773928121-c32242e63f39?w=400&h=300&fit=crop',
  'https://images.unsplash.com/photo-1564501049412-61c2a3083791?w=400&h=300&fit=crop',
];

function hotelImageCandidates(hotel) {
  if (!hotel || typeof hotel !== 'object') return [];
  const urls = [
    hotel.image,
    hotel.mainImage,
    hotel.photoUrl,
    hotel.thumbnailUrl,
    hotel.imageUrl,
    Array.isArray(hotel.images) ? hotel.images[0] : null,
  ].filter(Boolean);
  return urls;
}

function fallbackForIndex(hotel, index, pool, placeholder) {
  const len = pool.length;
  if (len === 0) return placeholder;
  let hash = index;
  const id = hotel?.id ?? hotel?.propertyId ?? hotel?.code ?? hotel?.name;
  if (id != null) {
    const s = String(id);
    for (let i = 0; i < s.length; i++) {
      hash = (hash * 31 + s.charCodeAt(i)) >>> 0;
    }
  }
  return pool[hash % len];
}

/**
 * @param {object} hotel - raw property / hotel from API
 * @param {number} index - position in list
 * @param {'large' | 'small'} [size='large'] - tile dimensions for stock fallbacks
 */
export function resolveHotelSectionImage(hotel, index, size = 'large') {
  const placeholder =
    size === 'small' ? HOTEL_SECTION_PLACEHOLDER_SMALL : HOTEL_SECTION_PLACEHOLDER_LARGE;
  const pool = size === 'small' ? FALLBACK_SMALL : FALLBACK_LARGE;

  for (const url of hotelImageCandidates(hotel)) {
    if (typeof url === 'string' && /^https?:\/\//i.test(url.trim())) {
      return url.trim();
    }
  }

  return fallbackForIndex(hotel, index, pool, placeholder);
}
